import {
  Box,
  Typography,
  type TypographyProps
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Icon } from "../../components";
import {
  useLevel,
  useType
} from "../../hooks";
import type { LearningObject } from "../../types";

type CardTypeProps =
  // & Omit<
  &  TypographyProps
  //   | "id"
  // >
  & Pick<
    LearningObject,
      // | "id"
      | "isSurvey"
      | "isTest"
      | "learningObjectTypology"
      | "learningObjectType"
      | "isEditorial"
    >
& Partial<
  Pick<
    LearningObject,
    | "ecmType"
    | "ecm_specialization"
  >
>

export function CardTypeRestyle({
  ecm_specialization,
  ecmType,
  isTest,
  isSurvey,
  isEditorial,
  learningObjectType,
  learningObjectTypology,
  ...props
}: CardTypeProps ) {
  const typeObjectLearning  = useType(learningObjectType, learningObjectTypology);
  const learningObjectTypologyType = useLevel(learningObjectTypology);
  const theme = useTheme();
  const { t }=useTranslation();


  return (
    <Box
      aria-hidden="true"
      sx={ {
        display: "flex",
        textAlign:"center",
        alignItems: "center",
        gap: "0.125rem"
      } }
      { ...props }
    >
      { isEditorial ? (
        <Typography sx={ { fontSize: "0.75rem",fontWeight: "500" } } color={ theme.customColors.exploreCardText }>
          { t("editorial") }
        </Typography>
      ) : (
        <>
          <Typography sx={ { fontSize: "0.75rem",fontWeight: "500" } } color={ theme.customColors.exploreCardText }>
            {
              isTest || isSurvey ?
                <Icon
                  icon={ isTest ? "test" : "survey" }
                  size={ 16 }/> : null
            }{
              isTest ?
                t("test") :

                isSurvey ?
                  t("survey") :
                  ecmType && ecm_specialization ?
                    ecmType :
                    typeObjectLearning || ""
            }</Typography>
          {
            !isTest && !isSurvey ?
              <Typography sx={ { fontWeight: "700", ml: 0.5,fontSize: "0.75rem" } } color={ theme.customColors.exploreCardText }>
                | { learningObjectTypologyType }
              </Typography> : null
          }
        </>
      ) }

    </Box>
  );
}
